<template>
  <div class="message">
    <div class="tab-box-form">
      <div class="tab-box-left">
        <p style="text-align: left">
          <b>履歴書設定</b>
          <br />
          <span style="color: #666; font-size: 12px"
            >ONにしますと、履歴書のアップロード用に<br />フォームを変更します。</span
          >
        </p>
      </div>
      <div class="tab-box-right" style="justify-content: center">
        <b-switch :value="uploadParameter.is_resume" @input="updateIsResume($event)" :disabled="scenarioEdit.is_confirm">切替</b-switch>
      </div>
    </div>
    <div class="tab-box-form">
      <div class="tab-box-left">
        <p style="text-align: left">
          <b>GoogleDrive設定</b>
          <br />
          <span style="color: #666; font-size: 12px"
            >ONにしますと、アップロードされたファイルがGoogleDriveに保存されます。</span
          >
        </p>
      </div>
      <div class="tab-box-right" style="justify-content: center; flex-wrap: wrap">
        <b-switch :value="uploadParameter.to_google_drive" @input="updateToGoogleDrive($event)" :disabled="scenarioEdit.is_confirm"
          >切替</b-switch
        >
        <p style="text-align: left; padding: 8px; color: red" v-if="!isGoogleDriveAuth">
          ※現在このアカウントはGoogleDrive連携がされていません。連携がされていない状態でONで保存しますとファイルがアップロードされません。連携を行う場合は「設定」>
          「外部連携」 > 「GoogleDrive連携」より連携をお願いいたします。
        </p>
      </div>
    </div>
    <div style="text-align: left;" v-if="!isSettingUser && uploadParameter.to_google_drive">
      <p style="text-align: left;">
        ※別のユーザーがGoogleDrive設定済みです。
      </p>
      <p style="text-align: left;">
        　変更する際はご注意ください。
      </p>
    </div>
    <div v-if="uploadParameter.to_google_drive && isGoogleDriveAuth">
        <!-- 保存先の選択 -->
        <p style="text-align: left; font-weight: 600; padding-top: 16px;">保存先を選択</p>
        <!-- GoogleFriveフォルダ一覧 -->
        <div v-if="!uploadParameter.drive_info || !isSettingUser">
          <!-- GoogleDrive保存情報なし -->
          <!-- または前回保存ユーザーと異なる時 -->
          <GoogleDriveFolderList
            style="width: 100%; padding: 16px;"
            :userId="userId"
            :isConfirm="scenarioEdit.is_confirm"
            @set-folder="setFolder"
          />
        </div>
        <div v-else>
          <!-- GoogleDrive保存情報あり -->
          <GoogleDriveFolderList
            style="width: 100%; padding: 16px;"
            :userId="userId"
            :folderId="uploadParameter.drive_info.id"
            :folderName="uploadParameter.drive_info.name"
            :mimeType="uploadParameter.drive_info.mime_type"
            :folderPath="uploadParameter.drive_info.folderPath"
            :isConfirm="scenarioEdit.is_confirm"
            @set-folder="setFolder"
          />
        </div>
      </div>
  </div>
</template>

<script>
import GoogleDriveFolderList from '@/components/organisms/common/GoogleDriveFolderList'
export default {
  components: {
    /** GoogleDrive一覧 */
    GoogleDriveFolderList,
  },
  props: {
    uploadParameter: {
      type: Object,
      required: true,
    },
    isGoogleDriveAuth: {
      type: Boolean,
      required: true,
    },
    userId: {
      type    : String,
      required: false,
      default : ''
    },
    scenarioEdit: {
      type: Object,
    }
  },
  mounted () {
    if (this.uploadParameter.user_uuid &&
        this.uploadParameter.user_uuid !== this.userId) {
      // 前回設定したユーザーと異なる場合は、一度GoogleDrive情報をクリアする
      this.$emit('update-drive-info', {
        id: '',
        name: '',
        mime_type: '',
        folderPath: []
      })
    }
  },
  computed: {
    isSettingUser () {
      let result = false
      if (!this.uploadParameter.uuid) {
        // 未設定
        result = true
      } else if (this.uploadParameter.uuid === this.userId) {
        // 同一ユーザー設定済み
        result = true
      } else {
        // 他ユーザー設定済み
        result = false
      }
      return result
    }
  },
  methods: {
    updateIsResume(value) {
      this.$emit('update-is-resume', value)
    },
    updateToGoogleDrive(value) {
      this.$emit('update-to-google-drive', value)
    },
    /** 選択フォルダ保存 */
    setFolder (folderId, folderName, mimeType, folderPath) {
      this.$emit('update-drive-info', {
        id: folderId,// フォルダID
        name: folderName,// フォルダ名
        mime_type: mimeType,// MIMEタイプ
        folderPath: folderPath// フォルダパス
      })
    },
  },
}
</script>

<style scoped lang="scss">
.message {
  background: #ffffff;
  max-height: calc(100vh - 300px);
  overflow: auto;
  padding: 8px;
  .comment {
    text-align: left;
    color: grey;
    font-size: 13px;
  }
  .tab-box {
    background: white;
    border: solid thin #ccc;
    border-radius: 8px;
    height: 350px;
    overflow-y: scroll;
    padding: 16px;
  }
  .tab-box::-webkit-scrollbar {
    width: 10px;
    height: 0px;
    visibility: hidden;
  }
  .tab-box-form {
    width: 100%;
    display: flex;
    padding: 8px;
  }
  .tab-box-left {
    width: 40%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .tab-box-right {
    width: 60%;
    font-size: 13px;
    padding: 10px;
    justify-content: flex-start;
    display: flex;
    align-items: center;
  }
}
.message::-webkit-scrollbar {
  width: 6px;
  height: 0px;
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/scenarioEdit/ScenarioEditUpload.vue